// Generated by CoffeeScript 1.6.3
(function() {
  var _this = this;

  rjm.model.BaseTrend = Backbone.RelationalModel.extend({
    subModelTypes: {
      'gaTrend': 'rjm.model.GATrend',
      'trend': 'rjm.model.Trend'
    }
  });

  rjm.model.Trend = rjm.model.BaseTrend.extend({
    partOfSupermodel: true,
    submodelType: 'trend',
    initialize: function(options) {
      if (!options.hasOwnProperty("id") || !options.hasOwnProperty("name") || !options.hasOwnProperty("operationColumn") || !options.hasOwnProperty("command") || !options.hasOwnProperty("timestampColumn") || !options.hasOwnProperty("clientId")) {
        throw "InvalidConstructorArgs - Trend";
      }
      this.set({
        minTime: null
      });
    },
    getId: function() {
      return this.get('id');
    },
    hasTimestamp: function() {
      var _ref;
      return ((_ref = this.get("timestampColumn")) != null ? _ref.get("sid") : void 0) > 0;
    },
    isGATrend: function() {
      return false;
    },
    fetchMinTime: function() {
      var _this = this;
      this.set({
        minTime: null
      });
      return $.when($.ajax({
        type: "GET",
        url: $.url('/client/' + this.get("clientId") + '/trend/' + this.get("id") + '/minTimestamp'),
        processData: false,
        contentType: 'application/json'
      })).done(function(minTime) {
        if (minTime === null) {
          _this.set({
            minTime: -1
          });
          return;
        }
        _this.set({
          minTime: minTime * 1000
        });
      });
    },
    relations: [
      {
        type: Backbone.HasOne,
        key: "operationColumn",
        relatedModel: "rjm.model.LSColumn",
        includeInJSON: true
      }, {
        type: Backbone.HasOne,
        key: "timestampColumn",
        relatedModel: "rjm.model.LSColumn",
        includeInJSON: true
      }, {
        type: Backbone.HasMany,
        key: "slicers",
        relatedModel: "rjm.model.Slicer",
        collectionType: "rjm.model.SlicerList",
        collectionOptions: function(model) {
          return {
            trendId: model.id,
            clientId: model.get("clientId")
          };
        }
      }
    ]
  });

  rjm.model.GATrend = rjm.model.BaseTrend.extend({
    partOfSupermodel: true,
    submodelType: 'gaTrend',
    initialize: function(options) {
      if (!options.hasOwnProperty("id") || !options.hasOwnProperty("name") || !options.hasOwnProperty("clientId")) {
        throw "InvalidConstructorArgs - GATrend";
      }
    },
    getId: function() {
      if (this.get('id').indexOf('ga') === 0) {
        return this.get('id').substring(2);
      }
      return this.get('id');
    },
    hasTimestamp: function() {
      return true;
    },
    isGATrend: function() {
      return true;
    },
    relations: [
      {
        type: Backbone.HasMany,
        key: "slicers",
        relatedModel: "rjm.model.GASlicer",
        collectionType: "rjm.model.GASlicerList",
        collectionOptions: function(model) {
          return {
            trendId: model.getId(),
            clientId: model.get("clientId")
          };
        }
      }
    ]
  });

  rjm.model.TrendList = rjm.model.ClientCollection.extend({
    model: rjm.model.Trend,
    initialize: function(models, options) {
      rjm.model.ClientCollection.prototype.initialize.apply(this, arguments);
      return _.bindAll(this, "url", "comparator");
    },
    url: function() {
      return $.url("/client/" + this.client + "/trend/metalist");
    },
    comparator: function(trend) {
      if (trend.get("name")) {
        return trend.get("name").toLowerCase();
      } else {
        return "";
      }
    }
  });

  rjm.model.GATrendList = rjm.model.ClientCollection.extend({
    model: rjm.model.GATrend,
    initialize: function() {
      rjm.model.ClientCollection.prototype.initialize.apply(this, arguments);
      return _.bindAll(this, "url");
    },
    url: function() {
      return $.url("/client/" + this.client + "/trend/galist");
    },
    parse: function(response) {
      _(response).each(function(value) {
        return value.id = "ga" + value.id;
      });
      return response;
    },
    getByCategory: function() {
      return this.groupBy("category");
    }
  });

}).call(this);
